class Office {
    constructor() {
        Office.bindFilters('.js-office-select');
        Office.bindFilters('.js-orders-status-select');
        // Office.bindValidityForms('.js-office-validity');
    }

    static bindFilters(filtersClass) {
        const filters = document.querySelectorAll(filtersClass);
        if (filters.length) {
            filters.forEach((item) => {
                Office.bind(item);
            });
        }
    }

    // static bindValidityForms(validityFormClass) {
    //     const formContainers = document.querySelectorAll(validityFormClass);
    //     if (formContainers.length) {
    //         formContainers.forEach((item) => {
    //             Office.bindValidityForm(item);
    //         });
    //     }
    // }

    static bind(item) {
        item.addEventListener('change', () => {
            Office.updateContainer(item);
        });
        Office.updateContainer(item);
    }

    static updateContainer(select) {
        const container = select.closest('.js-exhibitor-item');
        const officeSelect = container.querySelector('.js-office-select');
        const statusSelect = container.querySelector('.js-orders-status-select');

        container.querySelectorAll('.js-order-item').forEach((item) => {
            const officeValue = officeSelect ? officeSelect.value : '';
            const statusValue = statusSelect ? statusSelect.value : '';

            // parseInt for office (numeric IDs), direct string compare for status
            const hideByOffice = officeValue !== '' && parseInt(item.dataset.office, 10) !== parseInt(officeValue, 10);
            const hideByStatus = statusValue !== '' && item.dataset.orderStatus !== statusValue;

            item.classList.toggle('hidden', hideByOffice || hideByStatus);
        });
    }

    // static bindValidityForm(item) {
    //     const cta = item.querySelector('a.office-validity-cta');
    //     const form = item.querySelector('form.office-validity-form');
    //     if (cta && form) {
    //         cta.addEventListener('click', (e) => {
    //             e.preventDefault();
    //             form.classList.toggle('is-hidden');
    //         });
    //     }
    // }
}

export default Office;
